import React, { useEffect, useState } from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
import { ClockIcon, AlertCircleIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://pay.hotmart.com/C105998717T?checkoutMode=10';
export function PricingSection() {
  const fadeIn = useFadeIn();
  const [timeLeft, setTimeLeft] = useState(85408);
  useEffect(() => {
    const startDelay = setTimeout(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
      const timer = setInterval(() => {
        setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
      }, 1000);
      return () => clearInterval(timer);
    }, 3000);
    return () => clearTimeout(startDelay);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const books = [{
    emoji: '📘',
    text: '100 Citas con mi Hija (versión mamá e hija)'
  }, {
    emoji: '📗',
    text: '100 Citas con mi Hijo (versión mamá e hijo)'
  }, {
    emoji: '📙',
    text: '100 Citas con mi Hija (versión papá e hija)'
  }, {
    emoji: '📕',
    text: '100 Citas con mi Hijo (versión papá e hijo)'
  }];
  const bookFeatures = ['Actividades y desafíos familiares simples, económicos y divertidos', 'Momentos guiados para fortalecer la conexión emocional', 'Ideas para desconectarse de las pantallas y reconectarse entre ustedes', 'Espacios para escribir, reflexionar y guardar recuerdos'];
  const bonuses = [{
    emoji: '💌',
    text: 'Recuerdos para mi hija — 30 mensajes y reflexiones que ella recordará toda la vida'
  }, {
    emoji: '🎲',
    text: 'Adiós al aburrimiento — 52 planes económicos y entretenidos para disfrutar todo el año'
  }, {
    emoji: '🔑',
    text: 'Juegos secretos — Actividades que revelan lo que tus hijos realmente piensan y sienten'
  }, {
    emoji: '👵',
    text: 'Abuelita, cuéntame tu historia — Un viaje emocional por sus recuerdos'
  }, {
    emoji: '👴',
    text: 'Abuelito, cuéntame tu historia — Un legado familiar lleno de anécdotas'
  }, {
    emoji: '👩‍👧',
    text: 'Mamá, cuéntame tu historia — Un espacio íntimo para compartir experiencias'
  }, {
    emoji: '👨‍👦',
    text: 'Papá, cuéntame tu historia — Momentos de conexión profunda entre padre e hijo'
  }];
  return <section id="pricing" className="py-10 md:py-20 px-4 bg-[#111111] scroll-mt-10" data-id="element-162">
      <div className="max-w-3xl mx-auto" data-id="element-163">
        <div ref={fadeIn.ref} className={fadeIn.className} data-id="element-164">
          {/* Countdown Block */}
          <div className="text-center mb-8 md:mb-10" data-id="element-165">
            <div className="inline-flex items-center gap-2 bg-red-900/60 border border-red-500/40 text-red-300 font-bold text-xs md:text-base px-4 py-2 md:px-5 md:py-2 rounded-full mb-5 md:mb-6" data-id="element-166">
              <ClockIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-167" />
              <span data-id="element-168">OFERTA TERMINA EN:</span>
            </div>

            <div className="flex items-center justify-center gap-2 md:gap-3 mb-5 md:mb-6" data-id="element-169">
              <div className="bg-[#1a1a2e] border border-gray-700 rounded-xl px-3 py-2 md:px-6 md:py-4 min-w-[70px] md:min-w-[90px]" data-id="element-170">
                <div className="text-2xl md:text-5xl font-black text-white" data-id="element-171">
                  {hours.toString().padStart(2, '0')}
                </div>
                <div className="text-[10px] md:text-sm text-gray-500 font-medium mt-1" data-id="element-172">
                  hs
                </div>
              </div>
              <span className="text-xl md:text-4xl font-black text-red-400" data-id="element-173">
                :
              </span>
              <div className="bg-[#1a1a2e] border border-gray-700 rounded-xl px-3 py-2 md:px-6 md:py-4 min-w-[70px] md:min-w-[90px]" data-id="element-174">
                <div className="text-2xl md:text-5xl font-black text-white" data-id="element-175">
                  {minutes.toString().padStart(2, '0')}
                </div>
                <div className="text-[10px] md:text-sm text-gray-500 font-medium mt-1" data-id="element-176">
                  min
                </div>
              </div>
              <span className="text-xl md:text-4xl font-black text-red-400" data-id="element-177">
                :
              </span>
              <div className="bg-[#1a1a2e] border border-gray-700 rounded-xl px-3 py-2 md:px-6 md:py-4 min-w-[70px] md:min-w-[90px]" data-id="element-178">
                <div className="text-2xl md:text-5xl font-black text-white" data-id="element-179">
                  {seconds.toString().padStart(2, '0')}
                </div>
                <div className="text-[10px] md:text-sm text-gray-500 font-medium mt-1" data-id="element-180">
                  seg
                </div>
              </div>
            </div>

            <div className="flex items-center justify-center gap-2 text-yellow-400 font-bold text-xs md:text-base" data-id="element-181">
              <AlertCircleIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-182" />
              <span data-id="element-183">Después sube a su precio normal. No vuelve.</span>
            </div>
          </div>

          {/* Single Offer Card */}
          <div className="relative bg-gradient-to-b from-[#0d0d1a] to-[#111122] border-2 border-yellow-400 rounded-3xl p-6 md:p-10 shadow-2xl" data-id="element-184">
            {/* Limited time ribbon */}
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 z-10" data-id="element-185">
              <span className="inline-flex items-center gap-2 bg-gradient-to-r from-red-600 via-red-500 to-red-600 text-white text-sm md:text-base font-black px-5 md:px-7 py-2 md:py-2.5 rounded-full uppercase tracking-wider shadow-xl whitespace-nowrap" data-id="element-186">
                🎉 OFERTA POR TIEMPO LIMITADO
              </span>
            </div>

            {/* Intro */}
            <div className="mt-4 mb-6 md:mb-8 text-center" data-id="element-187">
              <p className="text-base md:text-xl text-gray-300 font-medium leading-relaxed" data-id="element-188">
                ✅ Estás a un paso de acceder al{' '}
                <span className="text-yellow-400 font-black" data-id="element-189">
                  Pack 100 Citas Familiares
                </span>
                , un conjunto único de libros digitales diseñados para
                fortalecer la conexión con tus hijos y toda tu familia.
              </p>
            </div>

            {/* What's included */}
            <div className="mb-6 md:mb-8" data-id="element-190">
              <h3 className="text-lg md:text-2xl font-black text-white mb-4 md:mb-5 text-center" data-id="element-191">
                🎁 Te llevás todo esto:
              </h3>

              <p className="text-sm md:text-base text-yellow-300 font-bold mb-3 md:mb-4" data-id="element-192">
                4 Libros Digitales con actividades, juegos y momentos únicos:
              </p>
              <div className="grid grid-cols-1 gap-2.5 mb-5 md:mb-6" data-id="element-193">
                {books.map((b, i) => <div key={i} className="flex items-start gap-3 bg-[#1a1a2e] border border-gray-700/50 rounded-xl p-3 md:p-3.5" data-id="element-194">
                    <span className="text-xl md:text-2xl flex-shrink-0" data-id="element-195">
                      {b.emoji}
                    </span>
                    <p className="text-sm md:text-base text-gray-300 font-medium" data-id="element-196">
                      {b.text}
                    </p>
                  </div>)}
              </div>

              <p className="text-sm md:text-base text-blue-300 font-bold mb-2 md:mb-3" data-id="element-197">
                ✨ Cada libro incluye:
              </p>
              <ul className="space-y-1.5 md:space-y-2 mb-5 md:mb-6 pl-2" data-id="element-198">
                {bookFeatures.map((f, i) => <li key={i} className="flex items-start gap-2 text-sm md:text-base text-gray-400" data-id="element-199">
                    <span className="text-green-400 mt-0.5 flex-shrink-0" data-id="element-200">
                      ✓
                    </span>
                    <span data-id="element-201">{f}</span>
                  </li>)}
              </ul>

              <p className="text-sm md:text-base text-yellow-300 font-bold mb-3 md:mb-4" data-id="element-202">
                🎁 Además, te llevás 7 bonos exclusivos:
              </p>
              <div className="grid grid-cols-1 gap-2.5" data-id="element-203">
                {bonuses.map((b, i) => <div key={i} className="flex items-start gap-3 bg-[#1a1a2e] border border-gray-700/50 rounded-xl p-3" data-id="element-204">
                    <span className="text-lg md:text-xl flex-shrink-0" data-id="element-205">
                      {b.emoji}
                    </span>
                    <p className="text-xs md:text-sm text-gray-300 font-medium" data-id="element-206">
                      {b.text}
                    </p>
                  </div>)}
              </div>
            </div>

            {/* Price block */}
            <div className="bg-[#0a0a14] border-2 border-yellow-400/50 rounded-2xl p-5 md:p-8 mb-6 md:mb-8 text-center" data-id="element-207">
              <p className="text-sm md:text-base text-gray-400 line-through mb-2" data-id="element-208">
                ¡Antes $25.00 USD!
              </p>
              <p className="inline-block bg-red-600 text-white text-xs md:text-sm font-black px-3 py-1 rounded-full uppercase tracking-wider mb-3" data-id="element-209">
                SOLO POR HOY
              </p>
              <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-210">
                <span className="text-sm md:text-base text-gray-400 font-medium" data-id="element-211">
                  USD
                </span>
                <span className="text-5xl md:text-7xl font-black text-yellow-400" data-id="element-212">
                  $9.90
                </span>
              </div>
              <p className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-213">
                🌎 ¡Pagalo en tu moneda local!
              </p>
            </div>

            {/* CTA */}
            <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-214">
              <div className="relative w-full group cta-pulse" data-id="element-215">
                <div className="absolute -inset-1 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-xl opacity-70 md:group-hover:opacity-100 transition duration-200" data-id="element-216"></div>
                <div className="relative w-full text-center font-black text-base md:text-2xl uppercase tracking-wide py-4 md:py-5 rounded-xl bg-gradient-to-b from-yellow-400 to-yellow-500 border-b-4 border-yellow-700 text-black shadow-2xl" data-id="element-217">
                  👉 SÍ, QUIERO LA OFERTA AHORA
                </div>
              </div>
            </a>

            <div className="flex flex-col items-center justify-center gap-2 mt-5 text-gray-500 text-xs md:text-sm" data-id="element-218">
              <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4" data-id="element-219">
                <span data-id="element-220">🔒 Pago 100% seguro</span>
                <span data-id="element-221">•</span>
                <span data-id="element-222">🛡️ Garantía 7 días</span>
              </div>
              <span data-id="element-223">
                🌎 Pagalo en tu moneda local — Tarjeta de crédito, débito y más
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}